// Client-side CSV export helpers. Pages build a header + rows array in
// whatever shape they render, then call `downloadCsv(filename, rows)`.

export function csvEscape(v: unknown): string {
  if (v == null) return '';
  const s = String(v);
  // Quote when the value contains a delimiter, quote, or newline.
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function downloadCsv(filename: string, rows: Array<Array<unknown>>) {
  const body = rows.map((r) => r.map(csvEscape).join(',')).join('\n');
  const blob = new Blob([body], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
